import { formatInventoryDisplayQty } from '#/modules/imsMgmt/inventoryStock/helper/displayInventoryQty';

/** Search Popover 篩選（read-routes 範例值） */
export const INVENTORY_STOCK_STATUS_FILTER_OPTIONS = [
  { value: 'ACTIVE', label: '有效' },
  { value: 'CLOSED', label: '已關閉' },
];

/** 列表／SideMsg 列顯示（含 API 可能回傳、Popover 未列之值） */
const INVENTORY_STOCK_STATUS_DISPLAY_LABELS = {
  ACTIVE: '有效',
  CLOSED: '已關閉',
  CONSUMED: '已用盡',
};

export function formatInventoryStockStatusLabel(value) {
  if (!value) {
    return '-';
  }

  return INVENTORY_STOCK_STATUS_DISPLAY_LABELS[value] ?? value;
}

/** Search Popover 篩選（read-routes 範例值） */
export const INVENTORY_STOCK_INV_STATUS_FILTER_OPTIONS = [
  { value: 'AVAILABLE', label: '可用' },
  { value: 'HOLD', label: '保留' },
];

/** 列表／SideMsg 列顯示（含 API 可能回傳、Popover 未列之值） */
const INVENTORY_STOCK_INV_STATUS_DISPLAY_LABELS = {
  AVAILABLE: '可用',
  HOLD: '保留',
  BLOCKED: '封鎖',
};

export function formatInvStatusLabel(value) {
  if (!value) {
    return '-';
  }

  return INVENTORY_STOCK_INV_STATUS_DISPLAY_LABELS[value] ?? value;
}

export function resolveInventoryStockMaterial(row) {
  return row?.mtr ?? row?.material ?? null;
}

export function formatBaseQty(row) {
  return formatInventoryDisplayQty(row);
}

export function formatWarehouseLocation(row) {
  const warehouse = row.warehouse;
  if (!warehouse) {
    return '-';
  }

  const warehouseLabel = [warehouse.code, warehouse.name].filter(Boolean).join(' ');
  const locationLabel = warehouse.location
    ? [warehouse.location.code, warehouse.location.name].filter(Boolean).join(' ')
    : '';

  if (warehouseLabel && locationLabel) {
    return `${warehouseLabel} / ${locationLabel}`;
  }

  return warehouseLabel || locationLabel || '-';
}
